export enum CoursesRequestStatuses {
  /**
   * Черновик
   */
  DRAFT = 'draft',

  /**
   * Отправлен в АТОЛ
   */
  SEND = 'send',

  /**
   * Заказ создан
   */
  ORDER_CREATED = 'order_created',

  /**
   * Ожидает оплаты
   */
  WAITING_PAYMENT = 'waiting_payment',

  /**
   * Оплачена
   */
  PAID = 'paid',
}

export const CoursesRequestStatusesTranslate: Record<string, string> = {
  [CoursesRequestStatuses.DRAFT]: 'Черновик',
  [CoursesRequestStatuses.SEND]: 'Отправлен в АТОЛ',
  [CoursesRequestStatuses.ORDER_CREATED]: 'Заказ создан',
  [CoursesRequestStatuses.WAITING_PAYMENT]: 'Ожидает оплаты',
  [CoursesRequestStatuses.PAID]: 'Оплачена',
};

export const courses_request_statuses = Object.keys(CoursesRequestStatusesTranslate).map((f: string) => ({
  text: CoursesRequestStatusesTranslate[f],
  value: f,
}));
